import Svg from '../Components/shared/Svg'

const LetterSvg = () => (
  <Svg
    width='16'
    height='13'
    viewBox='0 0 16 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1 11.5H15V4.63889L8.52778 8.68056H7.47222L1 4.63889V11.5ZM8 7.83333L15 3.45833V1.5H1V3.45833L8 7.83333ZM16 0.5V12.5H0V0.5H16Z'
      fill='#89CAF0'
    />
  </Svg>
)

export default LetterSvg
